import HbsIslemtanimDTO from 'src/models/GenelTanimlar/hbsislemtanimDTO';
import StkUrunTanimDTO from './StkUrunTanimDTO';

class StkUrunTanimAddDTO {
  
  constructor() {
    this.urunTanim=new StkUrunTanimDTO();
    this.islemTanim=new HbsIslemtanimDTO();
  }
  urunTanim: StkUrunTanimDTO;
  islemTanim: HbsIslemtanimDTO;
}

export default StkUrunTanimAddDTO;
